module.exports = __webpack_public_path__ + "img/set.c505ce14.png";